import type { Component } from 'vue'
import type { ClientFeatures } from '@/types/client-config'
import { LayoutDashboard, ClipboardList, BarChart3, Settings, Notebook } from 'lucide-vue-next'

export interface NavItem {
  label: string
  icon: Component
  to: string
  featureKey: keyof ClientFeatures
}

export const allNavItems: NavItem[] = [
  { label: 'Overview', icon: LayoutDashboard, to: '/overview', featureKey: 'overview' },
  { label: 'Sessions', icon: ClipboardList, to: '/sessions', featureKey: 'previousTests' },
  { label: 'Notes', icon: Notebook, to: '/notes', featureKey: 'highlights' },
  { label: 'Performance', icon: BarChart3, to: '/performance', featureKey: 'performance' },
  { label: 'Settings', icon: Settings, to: '/settings', featureKey: 'settings' },
]
